exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".juicer-container{padding:10px 0 80px}.juicer-container h1{font-family:brandon-grotesque,sans-serif;font-weight:400;font-style:normal;margin-bottom:60px;text-align:center}.box-row{display:flex;flex-direction:row;justify-content:space-between;padding:0;overflow-y:hidden!important}.juicer-feed h1.referral{display:none!important}.juicer-feed.j-initialized.j-modern.j-desktop.image-grid{height:800px;max-height:800px;overflow:hidden}.feed-item.j-instagram.j-video.jackieserviss{max-height:360px}@media (max-width:775px){.box-row .box{height:170px;width:47%}.juicer-container h1{font-size:25px}.box-row .box:last-of-type,.box-row .box:nth-child(3){display:none}.feed-item.j-instagram,.j-stack.galcolumn{width:100%!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bd501258","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Juicer.vue
// module id = 226
// module chunks = 0